export default __webpack_public_path__ + "static/media/settings-icon.4c4fe7cf.svg";